<template lang="pug">
div(v-if="dadosJson")
  el-tabs.tabs(
    @tab-click="handleClick",
    v-model="abaAtiva",
  )

    el-tab-pane.tab(name='informacoesadministrativas')
      span(slot="label")
        | Informações Administrativas &nbsp
      informacoes-administrativas-uc(
        :dadosJson="dadosJson"
      )

    el-tab-pane.tab(name='atoslegais')
      span(slot="label")
        | Atos Legais &nbsp
      atos-legais-uc(
        :dadosJson="dadosJson"
      )

    el-tab-pane.tab(name='contato')
      span(slot="label")
        | Contato &nbsp
      contato-uc(
        :dadosJson="dadosJson"
      )

    el-tab-pane.tab(name='localizacao')
      span(slot="label")
        | Localização &nbsp
      localizacao-uc(
        v-if="abaAtiva === 'localizacao'"
        :dadosJson="dadosJson"
      )

</template>

<script>

import AppDisplay from '@/components/AppDisplay'
import AppButton from '@/components/AppButton'
import AppResumoGeo from '@/components/resumo/AppResumoGeo'

import ListagemDocumentos from '@/components/informacoesCadastro/ListagemDocumentos'

import InformacoesCadastrante from '@/components/informacoesCadastro/cadastrosOnline/InformacoesCadastrante'
import InformacoesInteressado from '@/components/informacoesCadastro/cadastrosOnline/InformacoesInteressado'
import InformacoesImovel from '@/components/informacoesCadastro/cadastrosOnline/InformacoesImovel'
import InformacoesTermoCompromisso from '@/components/informacoesCadastro/InformacoesTermoCompromisso'
import InformacaoDesejada from '@/components/informacoesCadastro/cadastrosOnline/solicitacaoInformacao/InformacaoDesejada'
import InformacoesImovelSolicitacao from '@/components/informacoesCadastro/cadastrosOnline/solicitacaoInformacao/InformacoesImovelSolicitacao'
import InformacoesAforamentoImovel from '@/components/informacoesCadastro/cadastrosOnline/informacoesAforamento/InformacoesAforamentoImovel'
import InformacoesReurbColetivoImovel from '@/components/informacoesCadastro/cadastrosOnline/informacoesReurbColetivo/InformacoesReurbColetivoImovel'
import InformacoesQualificacaoPermuta from '@/components/informacoesCadastro/cadastrosOnline/informacoesPermuta/InformacoesQualificacaoPermuta'
import InformacoesImovelPermuta from '@/components/informacoesCadastro/cadastrosOnline/informacoesPermuta/InformacoesImovelPermuta'
import InformacoesImovelTransferencia from '@/components/informacoesCadastro/cadastrosOnline/transferenciaDireitos/InformacoesImovelTransferencia'
import InformacoesImovelCancelamento from '@/components/informacoesCadastro/cadastrosOnline/cancelamentoClausula/InformacoesImovelCancelamento'
import InformacoesCadastranteAreasPatrimoniais from '@/components/informacoesCadastro/cadastrosOnline/areasPatrimoniais/InformacoesCadastranteAreasPatrimoniais'
import InformacoesInteressadoAreasPatrimoniais from '@/components/informacoesCadastro/cadastrosOnline/areasPatrimoniais/InformacoesInteressadoAreasPatrimoniais'
import InformacoesAdministrativasUc from '../InformacoesAdministrativasUc.vue'
import AtosLegaisUc from '../AtosLegaisUc.vue'
import ContatoUc from '../ContatoUc.vue'
import LocalizacaoUc from '../LocalizacaoUc.vue'

export default {

  components: {
    AppDisplay,
    AppButton,
    InformacoesCadastrante,
    InformacoesAdministrativasUc,
    AtosLegaisUc,
    ContatoUc,
    LocalizacaoUc,
    InformacoesInteressado,
    InformacoesImovel,
    AppResumoGeo,
    ListagemDocumentos,
    InformacaoDesejada,
    InformacoesImovelSolicitacao,
    InformacoesAforamentoImovel,
    InformacoesQualificacaoPermuta,
    InformacoesReurbColetivoImovel,
    InformacoesImovelPermuta,
    InformacoesImovelTransferencia,
    InformacoesCadastranteAreasPatrimoniais,
    InformacoesInteressadoAreasPatrimoniais,
    InformacoesTermoCompromisso,
    InformacoesImovelCancelamento
  },

  props: {
    dadosJson: {
      required: true
    }
  },

  data () {
    return {
      abaAtiva: 'informacoesadministrativas',
      processo: null
    }
  },
  methods: {
    handleClick (tab) {
      this.abaAtiva = tab.name
    }
  }
}
</script>
<style lang="scss" scoped>
  span {
    font-size: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/informacoesCadastro/cadastrosOnline/CadastroUc.vue